<template>
    <v-container fluid>
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" v-on:close="showDismissibleAlert = false" :info="info" />

        <v-card :style="{
      'border-radius': '2px',
      border:
        '1px solid' + $store.getters.getColorPalette().panelBorderColorCode,
    }"
    flat
    :dark="$store.getters.getColorPalette().isDark"
    :color="$store.getters.getColorPalette().background2ColorCode">
    <v-card-title>
        <span :style="{'color':  $store.getters.getColorPalette().accentCode}" class="text-h5">{{ $store.getters.getTextMap().logbook_time_stats }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-subtitle>
        <v-row>
            <v-col>
                <v-simple-table v-if="!loading" :dark="$store.getters.getColorPalette().isDark" >
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    <strong>{{$store.getters.getTextMap().metrics}}
</strong>
                  </th>
                  <th class="text-left">
                    <strong>{{$store.getters.getTextMap().last_7_days}}</strong>
                  </th>
                  <th class="text-left">
                    <strong>{{$store.getters.getTextMap().last_30_days}}</strong>
                  </th>
                  <th class="text-left">
                    <strong>{{$store.getters.getTextMap().last_365_days}}</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                  
                <tr v-for="(item,index) in completedStats" :key="index">

                  <td><strong>
                    {{ item.metric_name }}
                  </strong></td>
                  <td>{{ item.last_7 }} Mins</td>
                  <td>{{ item.last_30 }} Mins</td>
                  <td>{{ item.last_365 }} Mins</td>

                 
                </tr>
              </tbody>
            </template>
          </v-simple-table>
            </v-col>
        </v-row>

        
    </v-card-subtitle>

        </v-card>

        
    </v-container>
</template>

<script>
import InfoAlert from '@/components/InfoAlert.vue';
import axios from 'axios';
// import VueApexCharts from "vue-apexcharts";
import moment from 'moment';
export default {
    name: 'ManufacturingLogbookTimeStats',
    components: {
        InfoAlert,
        // apexchart: VueApexCharts,
    },
    mounted(){

        this.getStats()

    },
    data(){
        return {
            loading:false,
            showDismissibleAlert:false,
            info:'',
            tableData:[],
            compTable:{
                completed_time:{metric:'completed_time',metric_name:'Avg Completion time',last_7:'-',last_30:'-',last_365:'-'},
                make_time:{metric:'make_time',metric_name:'Avg Make time',last_7:'-',last_30:'-',last_365:'-'},
                check_time:{metric:'check_time',metric_name:'Avg Check time',last_7:'-',last_30:'-',last_365:'-'},
                approve_time:{metric:'approve_time',metric_name:'Avg approval time',last_7:'-',last_30:'-',last_365:'-'},
            },
            rejTable:{
                completed_time:{metric:'completed_time',metric_name:'Avg Completion time',last_7:'-',last_30:'-',last_365:'-'},
                make_time:{metric:'make_time',metric_name:'Avg Make time',last_7:'-',last_30:'-',last_365:'-'},
                check_time:{metric:'check_time',metric_name:'Avg Check time',last_7:'-',last_30:'-',last_365:'-'},
                approve_time:{metric:'approve_time',metric_name:'Avg approval time',last_7:'-',last_30:'-',last_365:'-'},
            },


        }
    },
    computed:{
        completedStats(){

            return Object.values(this.compTable)

        },
        


    },
    methods:{
        async updateStat(payload,timeKey='last_30'){
            // console.log(payload)
            this.loading=true
            try{

                let response = await axios.post(this.$store.state.api+'getManufacturingLogbookTimeStats',payload,{headers: {
                    Authorization: 'Bearer '+ this.$store.state.jwt}})
                    // console.log(response.data)
                  if(response.data.status==='success'){

                    this.tableData=response.data.data

                    let temp=response.data.data
                    let comp=temp.find(a=>{return a.status=='completed'})
                    // console.log(comp)
                    if( !comp || comp.length==0){
                        return
                    }
                    for(let k in this.compTable){
                        this.compTable[k][timeKey]=Math.round(comp[k])
                        // console.log(k,this.compTable[k]['last_30'])
                    }



                  }else{
                    this.info=response.data.msg
                    this.showDismissibleAlert=true
                  }
                }catch(err){
                    this.info=err
                    this.loading=false
                    this.showDismissibleAlert=true
                    
                }
                this.loading=false
                
            

        },
        async getStats(){
            await this.updateStat({from_time:moment().subtract(7,'days').unix()},'last_7');
            await this.updateStat({from_time:moment().subtract(30,'days').unix()},'last_30');
            await this.updateStat({from_time:moment().subtract(365,'days').unix()},'last_365');

        },
        getStatsOld(){
            let payload={}
            this.loading=true
            axios.post(this.$store.state.api+'getChecklistTimeStats',payload,{headers: {
                  Authorization: 'Bearer '+ this.$store.state.jwt
                  }}).then(response=>{
                    // console.log(response.data)
                  if(response.data.status==='success'){

                    this.tableData=response.data.data

                    let temp=response.data.data
                    let comp=temp.find(a=>{return a.status=='completed'})
                    // console.log(comp)
                    for(let k in this.compTable){
                        this.compTable[k]['last_30']=comp[k]
                        // console.log(k,this.compTable[k]['last_30'])
                    }



                  }else{
                    this.info=response.data.msg
                    this.showDismissibleAlert=true
                  }
                  this.loading=false
                }).catch(err=>{
                    this.info=err
                    this.loading=false
                    this.showDismissibleAlert=true
                })

        },


    }



}
</script>